import FlightCampaignsLandingPageContent from './FlightCampaignsLandingPageContent'
import { useParams } from 'react-router-dom'
import { useFlightCampaign } from 'hooks/Flights/useFlightCampaign'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import Error404PageWithOffers from 'components/Pages/Error404PageWithOffers/Error404PageWithOffers'

function FlightCampaignsLandingPage() {
  const params = useParams<'id'>()
  const [campaign, fetching, error] = useFlightCampaign(params.id ?? '')

  if (error) {
    return <Error404PageWithOffers />
  }

  if (fetching || !campaign) {
    return <LoadingIndicator />
  }

  return (
    <FlightCampaignsLandingPageContent campaign={campaign} />
  )
}

export default FlightCampaignsLandingPage
